import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.overlay};
`;

const ModalContainer = styled.div`
  background: ${({ theme }) => theme.colors.mainBg};
  color: ${({ theme }) => theme.colors.text};
  max-width: 400px;
  margin: 100px auto;
  padding: 16px;
`;

export default function PluginModal({ plugin, onClose }) {
  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <h3>{plugin.name}</h3>
        <p>{plugin.description}</p>
        <button onClick={onClose}>Close</button>
      </ModalContainer>
    </Overlay>
  );
}
